import React from 'react';
import { FilterState } from '../types';
import { FilterPanel } from './filters/FilterPanel';

interface SidebarProps {
  filters?: FilterState;
  onFilterChange?: (filters: Partial<FilterState>) => void;
  className?: string;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ filters, onFilterChange, className, onClose }) => {
  // Default fallback if filters are missing (though AppShell should provide)
  const defaultFilters: FilterState = {
    searchQuery: '', locations: [], priceMin: '', priceMax: '', beds: null, baths: null,
    type: [], developer: 'All Developers', completion: [],
    sqftMin: '', sqftMax: '', ppsfMin: '', ppsfMax: '',
    priceRange: [0, 50000000], sqftRange: [0, 10000],
    // Ensure all required fields by TS are present, even if empty
  } as FilterState;

  const currentFilters = filters || defaultFilters;

  return (
    <aside className={`sticky top-24 self-start h-[calc(100vh-6rem)] w-96 animate-[fadeIn_0.5s_ease-out_forwards] border-r border-slate-100 bg-white/50 backdrop-blur-sm z-20 overflow-y-auto ${className || ''}`}>
      <FilterPanel
        filters={currentFilters}
        onFilterChange={onFilterChange || (() => { })}
        onClose={() => onClose?.()}
        onClear={() => onFilterChange?.({
          searchQuery: '', locations: [], priceMin: '', priceMax: '', beds: null, baths: null,
          type: [], developer: 'All Developers', completion: [],
          sqftMin: '', sqftMax: '', ppsfMin: '', ppsfMax: '',
          priceRange: [0, 50000000], sqftRange: [0, 10000]
        })}
      />
    </aside>
  );
};

export default Sidebar;
